module.exports = __webpack_public_path__ + "static/availability_2-53234a116c353ea0005bf8e6c9df229d.jpg";